import React, { Component } from 'react';
import axios from 'axios';
import { PersonalDetailsCol } from '../common/userData';
import { Load } from '../common/basic';
import enums from '../../config/enums';

module.exports = class DoctorDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Name: '',
            UserType: '',
            profession: '',
            Phone: '',
            Email: '',
            Address: '',
            Country: '',
            Patients: '',
            ActiveSince: ''
        }
    }

    componentDidMount() {
        this
            ._loading
            .Show();

        axios
            .get("/data/getDoctorDetails/" + this.props.doctorID)
            .then(function (data) {
                var userData = data.data[0];
                this
                    ._loading
                    .Hide();
                var initial;
                if (userData.Gender == "Male") {
                    initial = "Mr. ";
                } else {
                    initial = "Mrs. ";
                }
                this.setState({
                    Name: initial + userData.FirstName + ' ' + userData.LastName,
                    UserType: userData.UserType,
                    Profession: userData.Profession,
                    Phone: userData.CellPhoneNumber,
                    Email: userData.Email,
                    Address: userData.Address,
                    Country: userData.Country,
                    Patients: userData.PatientsCount,
                    ActiveSince: userData.ActiveSince
                });

            }.bind(this))
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
    }

    render() {
        var glyphiconPadding = {
            "paddingRight": "7px"
        };

        var editUrl = '/edit/' + this.props.doctorID;
        //console.log("re-render");
        return (
            <div className='DoctorDetails UserDetails'>

                <div className='container'>

                    <Load
                        ref={(loading) => {
                            this._loading = loading;
                        }} />

                    <div className='Name'>
                        {this.state.Name}
                        <div className='profileEdit'>
                            <span
                                className="glyphicon glyphicon-pencil"
                                style={glyphiconPadding}
                                aria-hidden="true"></span><a href={editUrl}>Edit Profile</a>
                        </div>
                    </div>

                    <div className='float-left'>
                        <PersonalDetailsCol FieldName="User Type:" FieldValue={this.state.UserType} />
                        <PersonalDetailsCol FieldName="Profession:" FieldValue={this.state.Profession} />
                        <PersonalDetailsCol FieldName="Mobile:" FieldValue={this.state.Phone} />
                        <PersonalDetailsCol FieldName="Email:" FieldValue={this.state.Email} />
                    </div>
                    <div className='float-left'>
                        <PersonalDetailsCol FieldName="Address:" FieldValue={this.state.Address} />
                        <PersonalDetailsCol FieldName="Country:" FieldValue={this.state.Country} />
                        <PersonalDetailsCol FieldName="Patients:" FieldValue={this.state.Patients} />
                        <PersonalDetailsCol
                            FieldName="Active since:"
                            FieldValue={this.state.ActiveSince} />
                    </div>

                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./modules/doctorSummary/DoctorDetails.jsx